module.exports = __webpack_public_path__ + "static/media/038.21826f58.jpg";